import getAxiosInstance from './axios-instance';
import env from '@/config/env';

const apiURLs = {
  order: env.ORDERS_API_URL,
  rating: env.RATING_API,
  routes: env.NEW_ROUTES_API_URL,
  clouder: env.CLOUDERS_API_URL,
  storage: env.STORAGE_API_URL,
  notification: env.NOTIFICATION_API_URL,
  auth: env.AUTH_API_URL,
  admin: env.ADMIN_API_URL,
  user: env.USER_API_URL,
};

const apiInstances = Object.entries(apiURLs).reduce((instances, [key, url]) => {
  instances[`${key}Instance`] = getAxiosInstance(url);
  return instances;
}, {});

export default apiInstances;
